import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleChannel(event) {
    const checkbox = event.target
    const channelId = checkbox.value
    const label = document.querySelector(`label[for="channel_${channelId}"]`)

    if (label) {
      if (checkbox.checked) {
        label.classList.remove('opacity-50')
      } else {
        label.classList.add('opacity-50')
      }
    }
  }
}